import { combineReducers } from 'redux'

export default combineReducers({
  app: require('./appRedux').reducer,
  filter: require('./filterRedux').reducer,
  celula: require('./celulaRedux').reducer,
  igrejas: require('./igrejaRedux').reducer
})



// WEBPACK FOOTER //
// ./src/Redux/index.js